import isNewCar from "@utils/isNewCar";
import isRenewal from "@utils/isRenewal";
import * as carEvents from "../car/actions/helpMe";
import * as newCarEvents from "../newCar/actions/helpme";
import * as renewalEvents from "@renewals/store/analyticsData/eventActions/helpMe";

const getProductEvents = () => {
  if (isRenewal()) {
    return renewalEvents;
  } else if (isNewCar()) {
    return newCarEvents;
  } else {
    return carEvents;
  }
};

const productEvents = getProductEvents();

export default productEvents;
